import React from "react";
import "./shop.css";

const SkeletonCard = ({ isMobile }) => (
  <div className="shop shop-4col col-md-4 col-4" style={{ animation: "none" }}>
    <div className="border-product skeleton-card">
      {/* Image placeholder */}
      <div className="shopBack skeleton-shimmer" style={{ minHeight: isMobile ? 120 : 220, marginBottom: isMobile ? 4 : 12 }} />

      <div className="shoptext" style={{ padding: isMobile ? "0 2px 4px" : "0 8px 8px" }}>
        {isMobile ? (
          <>
            <div className="skeleton-shimmer skeleton-line" style={{ height: 10, width: "60%", margin: "4px auto" }} />
            <div className="skeleton-shimmer skeleton-line" style={{ height: 14, width: "40%", margin: "4px auto" }} />
          </>
        ) : (
          <>
            <div className="skeleton-shimmer skeleton-line" style={{ height: 16, width: "80%", margin: "0 auto 10px" }} />
            <div className="skeleton-shimmer skeleton-line" style={{ height: 13, width: "55%", margin: "8px auto" }} />
            <div className="skeleton-shimmer skeleton-line" style={{ height: 12, width: "45%", margin: "8px auto" }} />
            <div className="skeleton-shimmer skeleton-line" style={{ height: 20, width: "35%", margin: "8px auto 0" }} />
          </>
        )}
      </div>
    </div>
  </div>
);

// Renders N skeleton cards in a grid that matches the real product grid
const SkeletonGrid = ({ count = 9, isMobile }) => (
  <>
    {Array.from({ length: count }).map((_, i) => (
      <SkeletonCard key={i} isMobile={isMobile} />
    ))}
  </>
);

export default SkeletonGrid;